import { render, staticRenderFns } from "./task-list-option-button.vue?vue&type=template&id=c3cba022&scoped=true"
import script from "./task-list-option-button.vue?vue&type=script&lang=js"
export * from "./task-list-option-button.vue?vue&type=script&lang=js"
import style0 from "./task-list-option-button.vue?vue&type=style&index=0&id=c3cba022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cba022",
  null
  
)

export default component.exports